var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchW = function SvgSearchW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-w_svg__Lager_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.93 15.15"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".search-w_svg__cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:.7px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-w_svg__Lager_1"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "search-w_svg__Ellipse_5",
    className: "search-w_svg__cls-1",
    cx: 6.76,
    cy: 6.76,
    r: 6.41
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-w_svg__Path_37768",
    className: "search-w_svg__cls-1",
    d: "m11.22 11.22 3.45 3.69-3.45-3.69Z"
  }))));
};
export default SvgSearchW;